/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListDocumentFileExtensionsQueryResponse,
  ListDocumentFileExtensionsQueryParams,
} from '../types/ListDocumentFileExtensions'

function getListDocumentFileExtensionsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/documents/file-extensions/` as const,
  }
  return res
}

/**
 * @description Get unique file extensions for user's company documents.
 * Returns list of objects with label and value for use in filters:
 * [
 * {"label": "PDF", "value": "pdf"},
 * {"label": "DOCX", "value": "docx"},
 * ...
 * ]
 * @summary List distinct file extensions in the library
 * {@link /api/v1/documents/file-extensions/}
 */
export async function listDocumentFileExtensions(
  params?: ListDocumentFileExtensionsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListDocumentFileExtensionsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListDocumentFileExtensionsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
